// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".params[data-v-c3663f8a] {\n  padding-left: 20px;\n  padding-bottom: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
